import { noop, omit } from 'mojito/utils';
import BetsUtils from './utils';

const NULL_SERVICE = {
    configure: noop,
    getBets: BetsUtils.voidResponder('betsService'),
    removeSavedBet: BetsUtils.voidResponder('betsService'),
};

const NULL_CASHOUT_SERVICE = {
    configure: noop,
    requestCashoutOffers: BetsUtils.voidResponder('cashoutService'),
    requestCashoutOffer: () => Promise.resolve(undefined),
    discardCashoutOffers: noop,
    cashout: BetsUtils.voidResponder('cashoutService'),
    addAutoCashoutRule: BetsUtils.voidResponder('cashoutService'),
    removeAutoCashoutRule: BetsUtils.voidResponder('cashoutService'),
};

/**
 * Singleton object that receives performance service config and spawn service instance.
 *
 * @class ServiceFactory
 * @name serviceFactory
 * @memberof Mojito.Services.Bets
 */
class ServiceFactory {
    constructor() {
        this.service = NULL_SERVICE;
        this.cashoutService = NULL_CASHOUT_SERVICE;
    }

    /**
     * Init factory.
     *
     * @function init
     *
     * @param {Mojito.Services.Bets.types.ServiceFactoryConfig} config - Service factory config object.
     *
     * @memberof Mojito.Services.Bets.serviceFactory
     */
    init({ service, serviceUrl, cashoutConfig = {} }) {
        this.service = service || NULL_SERVICE;
        this.service.configure({ serviceUrl });

        const { service: cashoutService } = cashoutConfig;
        this.cashoutService = cashoutService || NULL_CASHOUT_SERVICE;
        this.cashoutService.configure(omit(cashoutConfig, 'service'));
    }

    /**
     * Service getter.
     *
     * @function getService
     *
     * @returns {Mojito.Services.Bets.AbstractBetsService} Bets service instance.
     *
     * @memberof Mojito.Services.Bets.serviceFactory
     */
    getService() {
        return this.service;
    }

    /**
     * Cashout service getter.
     *
     * @function getCashoutService
     *
     * @returns {Mojito.Services.Bets.AbstractCashoutService} Cashout service instance.
     *
     * @memberof Mojito.Services.Bets.serviceFactory
     */
    getCashoutService() {
        return this.cashoutService;
    }
}

export default new ServiceFactory();
